<template>
  <div class="console-card-options">
    <icon class="trigger-icon" type="button" @click="showOptions($event)"
      >more_vert</icon
    >
    <SlideYUpTransition>
      <div v-if="showMenu" class="options smooth-shadow">
        <ul>
          <li
            v-for="option in options"
            :key="option.name"
            @click="$emit(option.event)"
          >
            <icon size="18">{{ option.icon }}</icon> {{ option.name }}
          </li>
        </ul>
      </div>
    </SlideYUpTransition>
  </div>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    options: Array,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    showOptions() {
      this.showMenu = !this.showMenu;
    },
    removeListener() {
      this.showOptions();
      document.removeEventListener("click", this.removeListener, false);
    },
  },
  watch: {
    showMenu(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener("click", this.removeListener);
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.console-card-options {
  position: absolute;
  right: 12px;
  top: 20px;
  z-index: 9;

  .trigger-icon {
    z-index: -1;
  }

  .options {
    display: flex;
    flex-direction: column;
    width: 150px;
    position: absolute;
    background: var(--color-secondary-light);
    right: 12px;
    border-radius: 5px;
    margin-bottom: 20px;
    border: 1px solid var(--border-color);
    z-index: 999;

    ul {
      display: flex;
      flex-direction: column;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 13px 15px;

        &:hover {
          color: var(--color-primary);
          background: var(--color-primary-light);
          cursor: pointer;
        }

        &:first-child {
          border-radius: 5px 5px 0 0;
        }

        &:last-child {
          border-radius: 0 0 5px 5px;
        }

        i {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
